// @flow
import { ACTION_ERROR, ACTION_SUCCESS } from '../constants/action-status';
import type { Schema } from 'normalizr';
import type { FormMessage } from './types';
import Constants from '../constants';

/**
 * Small helper to create REST actions in the way we need.
 */
export const restActionCreator = (
	promise: () => Promise<any>,
	type: string,
	transformer?: Function,
	schema?: Schema,
	params: Object = {},
) => ({
	type,
	params,
	transformer,
	meta: {
		schema,
	},
	promise,
});

export const entityActionCreator = (actionType: string, id: string) => ({
	type: `${actionType}_${ACTION_SUCCESS}`,
	params: { entityId: id },
});

export const genericActionCreator = (actionType: string, params: Object = {}) => ({
	type: `${actionType}_${ACTION_SUCCESS}`,
	params,
});

export const errorActionCreator = (
	actionType: string,
	errors: Array<FormMessage>,
	actionParams: Object = {},
) => ({
	type: `${actionType}_${ACTION_ERROR}`,
	payload: errors,
	params: actionParams,
});

export const messageActionCreator = (messages: Array<FormMessage>, actionParams: Object = {}) => ({
	type: Constants.ACTION_MESSAGE,
	payload: messages,
	params: actionParams,
});

/**
 * Create an error object for errorActionCreator function.
 *
 * @param messageKey message key
 * @param type AUI type : 'warning' | 'error' | 'success' | 'info'
 * @param params binding parameters
 * @param titleKey title key, if undefined then use <messageKey>.title
 */
export const createMessage = (
	messageKey: string,
	type: string = 'warning',
	params: Object = {},
	titleKey?: string,
): FormMessage => ({
	titleKey: titleKey || `${messageKey}.title`,
	messageKey,
	params,
	type,
});
